import { useTranslation } from 'react-i18next';

export default function StatsStrip() {
  const { t } = useTranslation();
  const stats = [
    { value: 'V', labelKey: 'stats.portfolio_companies' },
    { value: '3', labelKey: 'stats.continents' },
    { value: 'MMXXI', labelKey: 'stats.founded_in_zug' },
    { value: 'AG', labelKey: 'stats.swiss_ag' },
  ];

  return (
    <section
      data-testid="stats-strip"
      className="grid grid-cols-2 md:grid-cols-4 border-y border-[#0B1F3F]/10 bg-[#F5EFE1]"
    >
      {stats.map((s, i) => (
        <div
          key={s.labelKey}
          className={`p-8 md:p-12 flex flex-col ${
            i < stats.length - 1 ? 'md:border-r border-[#0B1F3F]/10' : ''
          } ${i % 2 === 0 ? 'border-r border-[#0B1F3F]/10 md:border-r' : ''}`}
        >
          <span className="font-serif text-4xl md:text-5xl text-[#0B1F3F] leading-none">{s.value}</span>
          <span className="mt-4 text-[10px] tracking-[0.2em] uppercase text-[#6B5B4A] font-sans">
            {t(s.labelKey)}
          </span>
        </div>
      ))}
    </section>
  );
}
